import { Box, Flex, Image } from '@chakra-ui/react'
import { FC } from 'react'
import { Helmet } from 'react-helmet'

import { IAuthLayoutProps } from '@base/@types/components/Layout/AuthLayout'

const AuthLayout: FC<IAuthLayoutProps> = ({ title, children }) => {
  return (
    <div>
      <Helmet>
        <title>{title} - SCL</title>
      </Helmet>
      <Flex
        alignItems="center"
        justifyContent="center"
        bgImg="url(/assets/images/background.png)"
        bgPos="bottom"
        bgSize="cover"
        minH="100vh"
        borderTop="solid 4px"
        borderColor="yellow.400"
      >
        <Box w="320px" p="36px" borderRadius="8px" bg="white">
          <Image
            mb="24px"
            maxH="52px"
            src="/assets/images/logo.png"
            alt="Leo Madeiras - Logo"
            mx="auto"
          />
          {children}
        </Box>
      </Flex>
    </div>
  )
}

export default AuthLayout
